import AuthApi from '@/api/auth';

import router from '@/router';

const getInitialToken = key => localStorage.getItem(key) || null;

export default {
  namespaced: true,

  state: {
    profile: null,
    accessToken: getInitialToken('vw_access_token'),
    refreshToken: getInitialToken('refresh_token'),
    idToken: getInitialToken('id_token'),
    loading: false,
    error: null,
  },

  actions: {
    async getUserProfile(ctx) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const accessToken = localStorage.getItem('vw_access_token');

        if (accessToken) {
          const response = await AuthApi.getProfile(accessToken);

          if (typeof response.data === 'object') {
            ctx.commit('setProfile', response.data);
          } else {
            ctx.dispatch('logout');
          }
        } else {
          ctx.dispatch('logout');
        }
      } catch (err) {
        ctx.commit('setError', err);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async getToken(ctx, code) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const uri = `${location.protocol}//${location.host}/auth-callback`;

        const params = {
          client_id: process.env.VUE_APP_GITLAB_APP_ID,
          code,
          grant_type: 'authorization_code',
          redirect_uri: uri,
        };

        const response = await AuthApi.getToken(params);

        const accessToken = response.data.access_token;
        const refreshToken = response.data.refresh_token;
        const idToken = response.data.id_token;

        localStorage.setItem('vw_access_token', accessToken);
        localStorage.setItem('refresh_token', refreshToken);
        localStorage.setItem('id_token', idToken);

        ctx.commit('setAccessToken', accessToken);
        ctx.commit('setRefreshToken', refreshToken);
        ctx.commit('setIdToken', idToken);
      } catch (err) {
        ctx.dispatch('logout');
        ctx.commit('setError', err);
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async refreshToken(ctx) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      const oldRefreshToken = localStorage.getItem('refresh_token');

      if (oldRefreshToken) {
        try {
          const uri = `${location.protocol}//${location.host}/auth-callback`;

          const params = {
            refresh_token: oldRefreshToken,
            grant_type: 'refresh_token',
            redirect_uri: uri,
          };

          const response = await AuthApi.getToken(params);

          if (!response.data.error) {
            const accessToken = response.data.access_token;
            const refreshToken = response.data.refresh_token;
            const idToken = response.data.id_token;

            localStorage.setItem('vw_access_token', accessToken);
            localStorage.setItem('refresh_token', refreshToken);
            localStorage.setItem('id_token', idToken);

            ctx.commit('setAccessToken', accessToken);
            ctx.commit('setRefreshToken', refreshToken);
            ctx.commit('setIdToken', idToken);
          } else {
            ctx.dispatch('logout');
          }
        } catch (err) {
          ctx.dispatch('logout');
          ctx.commit('setError', err);
        } finally {
          ctx.commit('setLoading', false);
        }
      } else {
        ctx.dispatch('logout');
      }
    },

    async logout(ctx, redirect = true) {
      localStorage.removeItem('vw_access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('id_token');

      ctx.commit('setProfile', null);
      ctx.commit('setAccessToken', null);
      ctx.commit('setRefreshToken', null);
      ctx.commit('setIdToken', null);

      if (redirect) router.push('/login');
    },

    async restrict(ctx) {
      ctx.dispatch('logout', false)
      router.push('/forbidden')
    }
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setProfile(state, data) {
      state.profile = data;
    },

    setAccessToken(state, token) {
      state.accessToken = token;
    },

    setRefreshToken(state, token) {
      state.refreshToken = token;
    },

    setIdToken(state, token) {
      state.idToken = token;
    },

    logout(state) {
      state.profile = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.idToken = null;
    },
  },

  getters: {
    loading: state => state.loading,
    error: state => state.error,
    profile: state => state.profile,
    name: state => (state.profile ? state.profile.name : ''),
    avatar: state => (state.profile ? state.profile.picture : ''),
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    idToken: state => state.idToken,
  },
};
